"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBSelect = exports.IMBSelectVariant = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var MBText_1 = require("../MBText");
var SelectorArrowsIcon_1 = require("../Icons/Arrows/SelectorArrowsIcon");
var mock_1 = require("../../utils/mock");
var IMBSelectVariant;
(function (IMBSelectVariant) {
    IMBSelectVariant[IMBSelectVariant["large"] = 0] = "large";
    IMBSelectVariant[IMBSelectVariant["medium"] = 1] = "medium";
    IMBSelectVariant[IMBSelectVariant["small"] = 2] = "small";
})(IMBSelectVariant = exports.IMBSelectVariant || (exports.IMBSelectVariant = {}));
var MBSelect = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.displayEmpty, displayEmpty = _d === void 0 ? true : _d, onChange = _a.onChange, _e = _a.value, value = _e === void 0 ? '' : _e, placeholder = _a.placeholder, placeholderIcon = _a.placeholderIcon, _f = _a.variant, variant = _f === void 0 ? IMBSelectVariant.large : _f, width = _a.width;
    var textVariant = function () {
        switch (variant) {
            case IMBSelectVariant.large:
                return "body2";
            default:
                return "body3";
        }
    };
    var renderArrow = function () {
        var arrowDistance = function () {
            switch (variant) {
                case IMBSelectVariant.small:
                    return 12;
                default:
                    return 16;
            }
        };
        return (jsx_runtime_1.jsx(core_1.Box, __assign({ display: "flex", position: "absolute", right: arrowDistance(), style: { pointerEvents: 'none' } }, { children: jsx_runtime_1.jsx(SelectorArrowsIcon_1.SelectorArrowsIcon, { size: 14 }, void 0) }), void 0));
    };
    var arrowPadding = function () {
        switch (variant) {
            case IMBSelectVariant.small:
                return 1.5;
            default:
                return 2;
        }
    };
    return (jsx_runtime_1.jsxs(StyledSelect, __assign({ width: width, disabled: disabled, onChange: onChange, value: value, disableUnderline: true, IconComponent: renderArrow, displayEmpty: displayEmpty, variant: variant }, { children: [placeholder && (jsx_runtime_1.jsx(core_1.MenuItem, __assign({ value: "" }, { children: jsx_runtime_1.jsxs(core_1.Box, __assign({ display: "flex", alignItems: "center", pr: arrowPadding() }, { children: [placeholderIcon, jsx_runtime_1.jsx(MBText_1.MBText, { ml: placeholderIcon ? 1 : 0, t: placeholder, opacity: 0.5, variant: textVariant(), textOverflow: "ellipsis", overflow: "hidden" }, void 0)] }), void 0) }), void 0)),
            data.map(function (e, i) { return (jsx_runtime_1.jsx(core_1.MenuItem, __assign({ value: e.value }, { children: jsx_runtime_1.jsxs(core_1.Box, __assign({ display: "flex", alignItems: "center", pr: arrowPadding() }, { children: [e.icon, ' ', jsx_runtime_1.jsx(MBText_1.MBText, __assign({ ml: e.icon ? 1 : 0, variant: textVariant(), textOverflow: "ellipsis", overflow: "hidden" }, { children: e.label }), void 0)] }), void 0) }), i)); })] }), void 0));
};
exports.MBSelect = MBSelect;
var StyledSelect = styled_components_1.default(function (_a) {
    var variant = _a.variant, rest = __rest(_a, ["variant"]);
    mock_1.mockFunction({ variant: variant });
    return (jsx_runtime_1.jsx(core_1.Select, __assign({}, rest, { MenuProps: {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
            getContentAnchorEl: null,
        } }), void 0));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    ", "\n\n    width: ", ";\n\n    & .MuiSelect-root {\n      ", "\n    }\n  }\n"], ["\n  && {\n    ", "\n\n    width: ",
    ";\n\n    & .MuiSelect-root {\n      ",
    "\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.body2;
}, function (_a) {
    var width = _a.width;
    return width ? (typeof width === 'string' ? width : width + "px") : '100%';
}, function (_a) {
    var variant = _a.variant;
    switch (variant) {
        case IMBSelectVariant.small:
            return "padding: 3px 12px;";
        case IMBSelectVariant.medium:
            return "padding: 7px 16px;";
        case IMBSelectVariant.large:
            return "padding: 12px 16px;";
        default:
            return "";
    }
});
var templateObject_1;
//# sourceMappingURL=MBSelect.js.map